import { defer, LoaderFunctionArgs } from 'react-router-dom';
import { IChainTrendingCoin, ITokenInfo } from '@kattana-io/common';
import { KattanaAPI } from '../../store/createStore';

export type tokenPageLoaderDataType = Record<string, IChainTrendingCoin> | null;

const tokenPageLoader = async ({ params, request }: LoaderFunctionArgs) => {
  const chain = params.chain || '';
  const address = params.address || '';

  let token;

  if ((window as any).coin) {
    const storedToken = (window as any).coin as ITokenInfo;

    const sameToken = storedToken.tokens?.find(
      (token) =>
        token.address.toLowerCase() === address.toLowerCase() &&
        token.network === chain
    );

    if (sameToken) {
      token = storedToken;
    }
  }

  if (!token) {
    token = await KattanaAPI.tokenInfo(chain, address, {
      params: {
        text: true,
        news: true,
        pairs: true,
      },
      signal: request.signal,
    });
  }

  const trendingCoins = KattanaAPI.chainTrending(chain, {
    signal: request.signal,
  });

  return defer({ token, trendingCoins });
};

export default tokenPageLoader;
